import Add from "../AddVisits/Add";
import React, { useCallback, useEffect, useState } from "react";
import { IVisit } from "../../interfaces";
import { get } from "../../_api";
import Pagination from "../Pagination/Pagination";
import ListElem from "../List/ListElem";
import { Button, Checkbox, Stack, Text } from "@mantine/core";

const perPage = 20;

const Visits: React.FC = () => {
  const [isAddVisible, setIsAddVisible] = useState(false);
  const [visits, setVisits] = useState<IVisit[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [onlyActive, setOnlyActive] = useState<boolean>(false);

  useEffect(() => {
    const active = localStorage.getItem("active");
    if (active !== null) {
      setOnlyActive(active === "true");
    }
  }, []);

  const updateVisits = useCallback(() => {
    get(`visits?cp=${currentPage}&active=${onlyActive}`).then((data) => {
      if (data) {
        setVisits(data.visits);
        setTotal(data.total);
      }
    });
  }, [currentPage, onlyActive]);

  useEffect(() => {
    updateVisits();
  }, [updateVisits]);

  const handleChangeActive = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOnlyActive(e.target.checked);
    setCurrentPage(1);
    localStorage.setItem("active", e.target.checked.toString());
  };

  return (
    <Stack gap="md" maw={1200} mx="auto" px="md" pb={250}>
      <Stack gap="sm" align="flex-start">
        <Button onClick={() => setIsAddVisible(!isAddVisible)}>
          Nowy termin
        </Button>
        <Checkbox
          label="Pokaż tylko aktualne"
          checked={onlyActive}
          onChange={handleChangeActive}
        />
      </Stack>

      {isAddVisible && <Add updateVisits={updateVisits} />}

      <Stack gap={0}>
        {visits.map((el, i) => (
          <ListElem
            key={el._id}
            id={el._id}
            order={i + 1 + (currentPage - 1) * perPage}
            link={`/visit/details/${el._id}`}
            infoBig={el.client?.name}
            infoSmall={el.client?.email}
            infoExtra={
              (el.payment?.status === "in-progress" && "Oczekujące") ||
              (el.payment?.status === "done" && "Zapłacono") ||
              undefined
            }
            date={el.date}
          />
        ))}
      </Stack>

      <Pagination
        total={total}
        perPage={perPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
      <Text size="sm" c="dimmed">
        Maksymalna ilość wpisów to 100, (po archiwalne wpisy skontaktuj się z
        administratorem)
      </Text>
    </Stack>
  );
};

export default Visits;
